/**
 * Angular CommonService.download(): the file name comes from the `Content-Disposition` header. Quirks kept on
 * purpose: only a part named exactly `filename` is used (so `filename*=` is ignored), quotes are NOT stripped,
 * a missing header gives an empty name. Unlike Angular, the object URL is released once the download has started, so
 * every downloaded PDF or zip does not stay in memory until the page reloads.
 */
export function fileNameFromDisposition(header: string | null): string | undefined {
  return header
    ?.split(';')
    .map((part) => (part ?? '').trimStart().split('='))
    .find((part) => part[0] === 'filename')
    ?.pop();
}

export function download(response: { body: Blob | null; headers: Headers }): void {
  const fileName = fileNameFromDisposition(response.headers.get('Content-Disposition'));
  const a = document.createElement('a');
  const url = URL.createObjectURL(response.body || new Blob());
  a.href = url;
  a.download = fileName ?? '';
  a.click();
  // The browser has taken the file once the click is handled; a short delay suits browsers that start it late.
  setTimeout(() => URL.revokeObjectURL?.(url), 10_000);
}

/** Angular CommonService.print(): a hidden iframe on the PDF blob, printed immediately, never cleaned up. */
export function print(body: Blob): void {
  const file = new Blob([body], { type: 'application/pdf' });
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = URL.createObjectURL(file);
  document.body.appendChild(iframe);
  iframe.contentWindow?.print();
}
